<template>
  <div id="app" class="p-3">
    <NavResult msg="Welcome Capsuleer" />
    <div class="p-3">
      <p>
        This application is designed to help you locate perfect planetary resources in Eve:Echoes.
      </p>
      <p>
        There are 'Perfect' locations for all resources except for Precious Alloy, so searches for Precious Alloy will return 'Rich' yields instead.
      </p>
      <p>
        The yield of a location is also influenced by the security rating of the system, so you may encounter instances of 'Rich' resources in null-sec that yield higher than 'Perfect' instances of the same resource in high-sec and low-sec.
      </p>
      <p>
        I had to draw the line somewhere to reduce the data down to something easier to manage, so I chose the perfection rating. If you disagree with that choice, then make your own resource locator.
      </p>
    </div>
    <div class="form row p-2">
      <div class="col-sm-3"></div>
      <div class="col-sm-2">
        <div>System</div>
        <autocomplete id="system" :items="systemNames" @input="selectedSystem = $event"></autocomplete>
      </div>
      <div class="col-sm-2">
        <div>Resource</div>
        <select class="custom-select" id="resource" v-model="selectedResource">
          <option
            v-for="resourceName in resourcesNames"
            v-bind:value="resourceName"
            v-bind:key="resourceName"
          >{{ resourceName }}</option>
        </select>
      </div>
      <div class="col-sm-2">
        <div>Max Jumps</div>
        <input type="number" id="jumps" name="quantity" min="1" max="20" v-model="selectedJumps" />
      </div>
      <div class="col-sm-3"></div>
    </div>
    <div class="row p-2">
      <div class="col-sm-5"></div>
      <div class="col-sm-2">
        <button v-on:click="getLast">Get Something</button>
      </div>
      <div class="col-sm-5"></div>
    </div>
    <div class="row p-2">
      <div class="col-sm-3"></div>
      <div class="col-sm-6">
        <table class="table table-hover table-bordered table-striped table-sm">
          <thead>
            <tr>
              <th scope="col">System Name</th>
              <th scope="col">Planet Name</th>
              <th scope="col">Security</th>
              <th scope="col">Output/Hr</th>
              <th scope="col">Jumps</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="result in results" v-bind:key="result.PlanetId">
              <th scope="row">{{ result.systemName }}</th>
              <td>{{ result.planetName }}</td>
              <td>{{ result.security }}</td>
              <td>{{ result.output }}</td>
              <td>{{ result.jumps }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-sm-3"></div>
    </div>
  </div>
</template>

<script>
import NavResult from './components/NavResult.vue'
import Autocomplete from './components/Autocomplete.vue'
import sysRss from './data/systemResources.json'

export default {
  name: 'App',
  components: {
    NavResult,
    Autocomplete
  },
  data: function () {
    return {
      systemNames: [],
      resourcesNames: [
        'Base Metals',
        'Condensates',
        'Condensed Alloy',
        'Coolant',
        'Construction Blocks',
        'Crystal Compound',
        'Dark Compound',
        'Fiber Composite',
        'Gleaming Alloy',
        'Glossy Compound',
        'Heavy Water',
        'Heavy Metals',
        'Industrial Fibers',
        'Ionic Solution',
        'Liquid Ozone',
        'Lucent Compound',
        'Lustering Alloy',
        'Motley Compound',
        'Nanites',
        'Noble Gas',
        'Noble Metals',
        'Opulent Compound',
        'Oxygen Isotopes',
        'Plasmoids',
        'Polyaramids',
        'Precious Alloy',
        'Reactive Gas',
        'Reactive Metals',
        'Sheen Compound',
        'Silicate Glass',
        'Smartfab Units',
        'Supertensile Plastics',
        'Suspended Plasma',
        'Toxic Metals'
      ],
      last: 'nothing yet',
      selectedSystem: '',
      selectedResource: 'Base Metals',
      selectedJumps: 1,
      results: [],
      systemResources: sysRss,
      jumpCount: 0,
      systemsSearched: [],
      currentNeighbors: [],
      nextNeighbors: [],
      currentSystem: {}
    }
  },
  methods: {
    getLast: function () {
      this.results = []
      this.jumpCount = 0
      this.systemsSearched = []
      this.currentNeighbors = []

      // Set starting system
      this.currentNeighbors.push(
        this.systemResources.find(sys => sys.systemName === this.selectedSystem)
          .systemId
      )

      while (this.jumpCount <= this.selectedJumps) {
        this.nextNeighbors = []
        // Check the outer border of unsearched neighbors
        this.currentNeighbors.forEach(systemId => {
          // Locate the system by id
          this.currentSystem = this.systemResources.find(
            sys => sys.systemId === systemId
          )
          // Check each planet for resources
          this.currentSystem.planets.forEach(planet => {
            if (planet.resource === this.selectedResource) {
              this.results.push({
                systemName: this.currentSystem.systemName,
                planetName: planet.planetName,
                output: planet.output,
                security: this.currentSystem.security,
                jumps: this.jumpCount
              })
            }
          })
          // Mark system as searched
          this.systemsSearched.push(this.currentSystem.systemId)
          // Add unsearched neighbors of the current system to the next jump of systems to be searched
          this.currentSystem.neighbors.forEach(nbor => {
            if (
              this.systemsSearched.indexOf(nbor) === -1 &&
              this.nextNeighbors.indexOf(nbor) === -1 &&
              this.currentNeighbors.indexOf(nbor) === -1
            ) {
              this.nextNeighbors.push(nbor)
            }
          })
        })
        // Set the new outer perimeter of neighbors
        this.currentNeighbors = this.nextNeighbors
        this.jumpCount++
      }
    }
  },
  watch: {
    selectedSystem: function (val) {
      this.$store.commit('changeSystem', val)
    }
  },
  mounted: function () {
    this.systemResources.forEach(system => {
      this.systemNames.push(system.systemName)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue